import { render } from "./confirm-user-details.vue?vue&type=template&id=4f556340"
import script from "./confirm-user-details.vue?vue&type=script&lang=js"
export * from "./confirm-user-details.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__